export default {
  root: {
    color: "var(--primary-color) !important",
    opacity: "100%"
  }
};
